module.exports = __webpack_public_path__ + "wxres/vue/img/setup005.b8551ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/setup005.jpg
// module id = pjE8
// module chunks = 59 60 62 63 64 65 66 67 68 69 70 71 72 73 74 75 76 77 78 79 80 81 82